import {z} from 'zod'

import {ButtonIconEnum, ButtonSizeEnum, ButtonVariantEnum} from '@sdox/api'

import {i18nValidation} from '../../../../../'

export type ButtonFormSchema = z.infer<typeof buttonSchema>
export type OptionalButtonFormSchema = z.infer<typeof optionalButtonSchema>
export type UnsetBtnType = Extract<OptionalButtonFormSchema, {btnType: 'unset'}>

const buttonInterfaceSchema = z.object({
  disclaimer: z.string().nullish(),
  label: z.string().nullish(),
  leadingIcon: z.nativeEnum(ButtonIconEnum).nullish(),
  size: z.nativeEnum(ButtonSizeEnum),
  trailingIcon: z.nativeEnum(ButtonIconEnum).nullish(),
  variant: z.nativeEnum(ButtonVariantEnum),
})

const hrefButtonSchema = buttonInterfaceSchema.extend({
  url: z.string().url({message: i18nValidation.invalidUrl}),
})

const copyButtonSchema = buttonInterfaceSchema.extend({
  content: z.string(),
})

const docButtonSchema = buttonInterfaceSchema.extend({
  identifier: z.string(),
})

const nestedContentButtonSchema = buttonInterfaceSchema.extend({
  identifier: z.string().optional(),
})

const downloadButtonSchema = buttonInterfaceSchema.extend({
  media: z.object({
    fileHash: z.string(),
  }),
  variant: z.nativeEnum(ButtonVariantEnum).default(ButtonVariantEnum.Filled),
  fileName: z.string().min(1, {message: i18nValidation.enterText}).default('Anhang'),
})

export const buttonSchema = z.discriminatedUnion('btnType', [
  z.object({
    btnType: z.literal('btnCopy'),
    btnCopy: copyButtonSchema,
  }),
  z.object({
    btnType: z.literal('btnHref'),
    btnHref: hrefButtonSchema,
  }),
  z.object({
    btnType: z.literal('btnDoc'),
    btnDoc: docButtonSchema,
  }),
  z.object({
    btnType: z.literal('btnNestedContent'),
    btnNestedContent: nestedContentButtonSchema,
  }),
  z.object({
    btnType: z.literal('btnDownload'),
    btnDownload: downloadButtonSchema,
  }),
])

export const optionalButtonSchema = z.discriminatedUnion('btnType', [
  z.object({
    btnType: z.literal('unset'),
  }),
  z.object({
    btnType: z.literal('btnCopy'),
    btnCopy: copyButtonSchema,
  }),
  z.object({
    btnType: z.literal('btnHref'),
    btnHref: hrefButtonSchema,
  }),
  z.object({
    btnType: z.literal('btnDoc'),
    btnDoc: docButtonSchema,
  }),
  z.object({
    btnType: z.literal('btnNestedContent'),
    btnNestedContent: nestedContentButtonSchema,
  }),
  z.object({
    btnType: z.literal('btnDownload'),
    btnDownload: downloadButtonSchema,
  }),
])
